export default "__VITE_ASSET__dl_W0LsE__"